import Subscriber from 'entities/Subscriber';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';

import { Backbone$Id } from 'types/typescript/Backbone';

class Subscribers extends Collection<Subscriber> {
  initialize() {
    this.url = '/subscribers';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Subscriber' is missing the following ... Remove this comment to see the full error message
    this.model = Subscriber;
  }
  comparator = (a: Subscriber, b: Subscriber): number => {
    return a.getName().localeCompare(b.getName());
  };

  sortByFirstName() {
    return this.sortBy((subscriber) => {
      return `${subscriber.getFirstName()} ${subscriber.getLastName()}`.toLowerCase();
    });
  }

  sortByLastName() {
    return this.sortBy((subscriber) => {
      return `${subscriber.getLastName()}, ${subscriber.getFirstName()}`.toLowerCase();
    });
  }

  sortBySubscribedAt() {
    return this.sortBy((subscriber) => {
      return subscriber.getSubscribedAt();
    });
  }

  static export(groupIds: Backbone$Id[]) {
    return apiRequest('/subscribers/export', 'POST', {
      group_ids: groupIds,
    });
  }
}

export default Subscribers;
